module.exports = __webpack_public_path__ + "img/1280x720-Party.f3221aa0.jpg";